import React from 'react';
// see https://github.com/AdeleD/react-paginate for more information
import ReactPaginate from 'react-paginate';
import './PayerPagination.scss';
import { PropTypes } from 'prop-types';

const PayerPagination = ({ numberOfPages, page, setPage }) => {
  return (
    <ReactPaginate
      previousLabel="<"
      nextLabel=">"
      breakLabel="..."
      pageCount={numberOfPages}
      marginPagesDisplayed={1}
      pageRangeDisplayed={5}
      forcePage={page}
      onPageChange={({ selected }) => setPage(selected)}
      containerClassName="pagination"
      pageLinkClassName="pageLink"
      breakLinkClassName="pageLink"
      previousLinkClassName="pageLink"
      nextLinkClassName="pageLink"
      activeLinkClassName="active"
    />
  );
};

PayerPagination.propTypes = {
  numberOfPages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
};

export { PayerPagination };
